<template>
	<section class="wrapper flex_center_center">
		<div class="main">
			<h2>申请成为代理商</h2>
			<p>1.代理商可在平台购买激活码，激活码云机时长三十天起步。</p>
			<p>2.被邀用户可在平台进行激活码兑换，兑换云机；兑换云机成功后开始计时长。</p>
			<p>3.云机激活码有效期：永久。</p>
			<el-button type="primary">申请</el-button>
		</div>
	</section>
</template>

<script setup>
	import {
		ref,
		reactive,
		computed,
		onMounted,
		onUnmounted,
		nextTick,
		watch,
	} from 'vue';
	import request from '@/utils'
	import {
		ElMessage,
		ElMessageBox,
		ElLoading,
		ElIcon
	} from 'element-plus';
	import {
		useStore
	} from 'vuex';
	const store = useStore();
	const state = reactive({

	})
</script>

<style lang="less" scoped>
	.wrapper{
		background-color: #f0fafe;
		border-radius: 10px;
		position: relative;
		.main{
			text-align: left;
			p{
				margin: 20px 0;
			}
			.el-button{
				padding: 20px 40px;
			}
		}
	}
</style>